import { DialogTemplate } from 'inpock-ui-react';

const DialogModuleName = 'cart.tsx';

const Template = {
  add: {
    success: () => (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="cart-add"
        title="장바구니에 담았어요 😎"
        message={<>장바구니에 상품이 추가되었어요</>}
      />
    ),
    same_market: () => (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="cart-same-market"
        title="장바구니에는 동일 마켓의 상품만 담을 수 있어요"
        message={
          <>
            선택한 상품을 담을 경우,
            <br />
            이전에 담은 상품은 삭제돼요.
          </>
        }
      />
    ),
  },
  delete: {
    confirm: () => (
      <DialogTemplate
        moduleName={DialogModuleName}
        classSuffix="cart-delete-confirm"
        title="상품 삭제 🗑"
        message={<>선택한 상품을 삭제할까요?</>}
      />
    ),
  },
};

export default Template;
